import * as yup from "yup";

const schema = yup.object().shape({
  name: yup.string().required().label("Name"),
  samplerContact: yup
    .string()
    .matches(/^\d{10}$/, "Sampler Contact must be a 10-digit number")
    .required()
    .label("Sampler Contact"),
  address: yup.string().required().label("Address"),
  pincode: yup
    .string()
    .matches(/^\d{6}$/, "Pincode must be a 6-digit number")
    .required()
    .label("Pincode"),
  email: yup.string().email("Invalid email format").required().label("Email"),
  district: yup.string().required().label("District"),
  state: yup.string().required().label("State"),
  agency: yup.string().required().label("Agency"),
  operatingStates: yup
    .array()
    .min(1, "At least one operating state must be selected")
    .required()
    .label("Operating States"),
  operatingDistricts: yup
    .array()
    .min(1, "At least one operating district must be selected")
    .required()
    .label("Operating Districts"),
});

export default schema;
